import { apiDataManagerBaseURL } from '../../authentication/Global';
import { authenticationCentral } from '../../authentication/Authentication';
import { API, HTTPMethod, ContentType } from '../APICentral';

const currencyApiRoutes = {
    list: apiDataManagerBaseURL + "currency/",
    load: apiDataManagerBaseURL + "currency/",
    create: apiDataManagerBaseURL + "currency/",
    update: apiDataManagerBaseURL + "currency/",
    delete: apiDataManagerBaseURL + "currency/",
};

export class CurrencyAPI {
    static list(provider = '') {
        const url = currencyApiRoutes.list;

        return API.authenticatedRequest({
            url: provider === '' ? url : `${url}?provider=${provider}`,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static load(id) {
        const url = `${currencyApiRoutes.load}${id}`;

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static create(model, provider = '') {
        const url = currencyApiRoutes.create;

        return API.authenticatedRequest({
            url: provider === '' ? url : `${url}?provider=${provider}`,
            method: HTTPMethod.POST,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(model)
        });
    }

    static update(id, model) {
        const url = `${currencyApiRoutes.update}${id}`;

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.PUT,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(model)
        });
    }

    static delete(id, provider = '') {
        const url = `${currencyApiRoutes.delete}${id}`;

        return API.authenticatedRequest({
            url: provider === '' ? url : `${url}?provider=${provider}`,
            method: HTTPMethod.DELETE,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }
}



// WEBPACK FOOTER //
// ./src/api/datamanager/CurrencyAPI.js